import Rollbar from 'rollbar';
import { createRollbarConfig } from '@shared/app/utils/rollbar/createRollbarConfig';
import { getStatusCode } from '@shared/app/utils/rollbar/getStatusCode';
import { defineNuxtPlugin, useRuntimeConfig } from '#app/nuxt';

export default defineNuxtPlugin((nuxtApp) => {
  const {
    public: { rollbarClientAccessToken, commitHash, APP_ENV },
  } = useRuntimeConfig();

  const rollbar = new Rollbar(
    createRollbarConfig({
      accessToken: rollbarClientAccessToken,
      commitHash: commitHash,
      environment: APP_ENV,
      scrubFields: ['name', 'email', 'password'],
      // NOTE: CDN経由の外部JSのエラーを受け取らないために設定している
      hostSafeList: [
        'dietplus.jp',
        'b.dietplus.jp',
        // NOTE: ローカルで動かしたくなったとき用に指定しておく
        'kiwi-user.dietplus.localhost',
      ],
    }),
  );

  function errorHandler(error: unknown) {
    const statusCode = getStatusCode(error);
    if (statusCode !== null && statusCode >= 400 && statusCode < 500) return;

    // NOTE: エラーの型の特定は難しいので eslint-disable-next-line で除外する
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rollbar.error(error as any);
  }

  nuxtApp.hook('vue:error', errorHandler);
  nuxtApp.hook('app:error', errorHandler);

  return {
    provide: {
      rollbar,
    },
  };
});
